import snsAxiosClient from '../common/http/http-sns';
import formatString from '../utils/formatString';
import { get } from 'lodash';

export type otaItemType = {
  itemBpn: string;
  qty: number;
  frequency: {
    unit: string;
    count: number;
  };
};

function saveOtaToSnsItemApi(environmentVariables, user, otaItem: otaItemType) {
  const options = {
    headers: {
      ...get(environmentVariables, 'API_HEADERS_POST_V1'),
      Authorization: `Bearer ${get(user, 'authToken')}`,
    },
  };
  return snsAxiosClient(options).post(
    formatString(get(environmentVariables, 'SNS_ADD_SUBSCRIPTION_ONETIME'), {
      UUID: get(user, 'UUID'),
    }),
    otaItem,
  );
}

export default saveOtaToSnsItemApi;
